import React, { useMemo } from 'react';
import clsx from 'clsx';
import * as PropTypes from 'prop-types';

import { MATRIX_TIMELINE_EVENT_TYPES } from '$app-web/components/chat/constants';
import Avatar from '$app-web/ui-kit/components/avatar';
import ButtonBase from '$app-web/ui-kit/components/button-base';

import { useChatUserData, useCurrentStudyId, useDynamicMethods } from '../../../../state/chat-client.state';
import MessageBubble from './message-bubble';
import classes from './styles.module.scss';

const MessageItem = (props) => {
    const { direct, event, isMessageSequenceEnd, isMessageSequenceFirst, otherMembersLastReadMarker } = props;

    const chatUserData = useChatUserData();
    const currentStudyId = useCurrentStudyId();
    const chatDynamicMethods = useDynamicMethods();

    const isVoipMessage = useMemo(
        () =>
            [
                MATRIX_TIMELINE_EVENT_TYPES.CALL_ANSWER,
                MATRIX_TIMELINE_EVENT_TYPES.CALL_REJECT,
                MATRIX_TIMELINE_EVENT_TYPES.CALL_HANGUP,
                MATRIX_TIMELINE_EVENT_TYPES.CALL_INVITE,
            ].includes(event.getType()),
        [event]
    );

    const userData = useMemo(
        () => chatDynamicMethods.getStudyUserDataByMatrixId(currentStudyId, event.getSender()),
        [chatDynamicMethods, currentStudyId, event]
    );

    const isRoommate = useMemo(() => chatUserData.userId !== event.getSender(), [event, chatUserData.userId]);

    return (
        <div className={clsx('item', classes.root)}>
            <div className={clsx('flex items-end', chatUserData.userId === event.getSender() && 'reverse')}>
                {!direct &&
                    isRoommate &&
                    (isMessageSequenceEnd ? (
                        <ButtonBase
                            className={clsx('item', classes.avatarWrapper)}
                            onClick={() => chatDynamicMethods.setCurrentRoomIdByUserId(userData?.id)}
                        >
                            <Avatar
                                colorValue={userData?.avatar?.color}
                                label={userData?.avatar?.label || event.getSender()}
                                size="sm"
                                src={userData?.avatar?.url}
                            />
                        </ButtonBase>
                    ) : (
                        <div className={clsx('item', classes.avatarWrapper)} />
                    ))}
                <div
                    className={clsx(
                        'item',
                        isVoipMessage ? classes.voipBubble : classes.bubble,
                        !isRoommate ? classes.borderRadiusReverse : classes.borderRadius
                    )}
                >
                    <MessageBubble
                        {...(!direct &&
                            isRoommate &&
                            isMessageSequenceFirst && {
                                title: { text: userData?.label, color: userData?.avatar?.color },
                                onTitleClick: () => chatDynamicMethods.setCurrentRoomIdByUserId(userData?.id),
                            })}
                        isVoipMessage={isVoipMessage}
                        event={event}
                        chatUserData={chatUserData}
                        otherMembersLastReadMarker={otherMembersLastReadMarker}
                    />
                </div>
            </div>
        </div>
    );
};

MessageItem.defaultProps = {
    otherMembersLastReadMarker: undefined,
};

MessageItem.propTypes = {
    direct: PropTypes.bool.isRequired,
    event: PropTypes.oneOfType([PropTypes.object]).isRequired,
    isMessageSequenceEnd: PropTypes.bool.isRequired,
    isMessageSequenceFirst: PropTypes.bool.isRequired,
    otherMembersLastReadMarker: PropTypes.oneOfType([PropTypes.object]),
};

export default MessageItem;
